export interface StringDevtoolState {
  active: boolean;
}

export interface StringDevtoolHotkey {
  key: string;
  shiftKey?: boolean;
  ctrlKey?: boolean;
  altKey?: boolean;
  metaKey?: boolean;
}

export interface StringDevtoolSubBadge {
  id: string;
  icon: string;
  label: string;
  /** Extra attribute used as a CSS selector hook (e.g. "data-string-grid-global-toggle"). */
  selectorAttribute?: string;
  /** Additional data-* attributes applied to the badge button. */
  attributes?: Record<string, string | boolean | number | null | undefined>;
  onClick: (anchorElement?: HTMLElement) => void;
}

export interface StringDevtoolDefinition {
  id: string;
  label: string;
  icon: string;
  order?: number;
  group?: number;
  hotkey?: StringDevtoolHotkey;
  subBadges?: StringDevtoolSubBadge[];
  getState: () => StringDevtoolState;
  setActive: (active: boolean) => void;
  subscribe?: (listener: (state: StringDevtoolState) => void) => () => void;
}

export interface StringDevtoolProvider {
  getDevtoolDefinition(): StringDevtoolDefinition | null;
}

export function isStringDevtoolProvider(value: unknown): value is StringDevtoolProvider {
  return (
    typeof value === "object" &&
    value !== null &&
    "getDevtoolDefinition" in value &&
    typeof (value as StringDevtoolProvider).getDevtoolDefinition === "function"
  );
}
